<template>
    <div id='app'>
        <Logo id='logo'/>
        <Home/>
    </div>
</template>

<script>
import Home from '@/views/Home.vue'
import Logo from '@/components/Logo.vue'

export default {
    name: 'app',
    components: {
        Home,
        Logo
    }
};
</script>

<style lang='scss'>

@import './styles/fonts';
@import './styles/mixins';
@import './styles/reset';
@import './styles/vars';

body {
    font-family: $font-regular-text;
    background: black;
    color: white;
}

#nav {
    position: fixed;
    top: 0; right: 0;
    color: white;
    z-index: 2000;
    display: none;
}

#menu {
    position: fixed;
    display: none;
}

#logo {
    background: black;
    padding: vw(25);
    position: fixed;
    top: 0; left: 0;
    width: vw(90);
    height: vw(90);
    height: auto;
    z-index: 9001;
    display: flex;
    align-items: center;
    justify-content: center;
}

h1, h2, h3, h4 {
    margin: 0;
    font-family: $font-bold-headline;
    font-weight: normal;
}

h1 {
    @include fluid-type(24px, 102px);
}

h2 {
    @include fluid-type(8px, 30px);
}

h4 {
    @include fluid-type(8px, 24px);
}

p {
    @include fluid-type(8px, 24px);
    margin: 0;
}

</style>